<template src="./template.html"></template>
<script>
import _extend from 'lodash/extend'

import urlUtils from 'utils/urlUtils'

const DEFAULT_IMAGE_DIMENSIONS = {
  h: '150px',
  w: '150px',
}

const IMAGE_DIMENSIONS = {
  xxx: {
    h: '210px',
    w: '281px',
    vH: '210px',
    vW: '281px',
  },
}

export default {
  name: 'event-card-3',
  props: {
    venueId: {
      type: String,
      required: false,
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    event: {
      type: Object,
      required: true,
    },
    //THEMEING
    theme: {
      type: String,
      default: 'theme-light',
    },
    buttonText: {
      type: String,
      default: 'Get Tickets',
    },
    buttonBgColor: {
      type: String,
    },
    buttonTextColor: {
      type: String,
    },
    imageWidth: {
      type: Number,
      default: 350,
    },
  },
  data() {
    return {}
  },
  computed: {
    buttonBgColorSanitized() {
      if (!this.buttonBgColor) return null

      if (!this.buttonBgColor.startsWith('#')) return `#${this.buttonBgColor}`

      return this.buttonBgColor
    },
    buttonTextColorSanitized() {
      if (!this.buttonTextColor) return null

      if (!this.buttonTextColor.startsWith('#')) return `#${this.buttonTextColor}`

      return this.buttonTextColor
    },
    imageDimensions() {
      const customVenueDimensions = IMAGE_DIMENSIONS[this.venueId]

      if (customVenueDimensions) {
        if (this.direction === 'vertical') {
          return {
            h: customVenueDimensions.vH,
            w: customVenueDimensions.vW,
          }
        }

        return customVenueDimensions
      }

      if (this.direction === 'vertical') {
        return _extend({}, DEFAULT_IMAGE_DIMENSIONS, {
          h: '210px',
        })
      }

      return DEFAULT_IMAGE_DIMENSIONS
    },
  },
  methods: {
    onEventClick() {
      this.$emit('eventClick', this.event)
    },
    imgLoaded() {
      this.$emit('updated')
    },
    getImageUrl(src) {
      if (!src) return ''

      return urlUtils.optimizedImageUrl(src, {
        width: this.imageWidth,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventCard3/index.vue